import React, { useState } from "react";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import { CustomInput } from "../../design/components/customComponents";
import { validateURL } from "../../../utility-functions";
import classes from "./IntegrationSettingsModal.module.css";

const LeadSquaredConfigModal = ({
  visible,
  closeModal,
  handleSave,
  config,
}) => {
  const [inputs, setInputs] = useState({
    call_log_api: { value: config?.call_log_api, error: "" },
    agent_popup_api: { value: config?.agent_popup_api, error: "" },
    call_route_api: { value: config?.call_route_api, error: "" },
    call_log_update_api: { value: config?.call_log_update_api, error: "" },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => {
      let error = "";
      if (name === "call_log_api") {
        const encodedValue = encodeURI(value.trim());
        error = value && !validateURL(encodedValue) ? "Please enter a valid URL" : "";
      } else if (
        (name === "agent_popup_api" ||
          name === "call_route_api" ||
          name === "call_log_update_api") &&
        value
      ) {
        const encodedValue = encodeURI(value.trim());
        error = !validateURL(encodedValue) ? "Please enter a valid URL" : "";
      }
      return {
        ...prev,
        [name]: {
          value,
          error,
        },
      };
    });
  };

  const handleConnect = async () => {
    if (
      inputs.call_log_api.error ||
      inputs.agent_popup_api.error ||
      inputs.call_route_api.error ||
      inputs.call_log_update_api.error
    )
      return;
    handleSave &&
      (await handleSave(
        {
          call_log_api: inputs.call_log_api.value,
          agent_popup_api: inputs.agent_popup_api.value,
          call_route_api: inputs.call_route_api.value,
          call_log_update_api: inputs.call_log_update_api.value,
        },
        Object.keys(config ?? {})?.length > 0 ? "put" : "post"
      ));
    closeModal();
  };

  const handleCancel = () => {
    setInputs({
      call_log_api: { value: config?.call_log_api, error: "" },
      agent_popup_api: { value: config?.agent_popup_api, error: "" },
      call_route_api: { value: config?.call_route_api, error: "" },
      call_log_update_api: { value: config?.call_log_update_api, error: "" },
    });
    closeModal();
  };

  const body = (
    <div className={classes.lsqFormContainer}>
      <CustomInput
        label="Call Log API"
        name="call_log_api"
        value={inputs.call_log_api}
        handleChange={handleChange}
        type="text"
        placeholder="Enter Call Log API URL"
      />
      <CustomInput
        label="Agent Popup API"
        name="agent_popup_api"
        value={inputs.agent_popup_api}
        handleChange={handleChange}
        type="text"
        placeholder="Enter Agent Popup API URL"
      />
      <CustomInput
        label="Call Route API"
        name="call_route_api"
        value={inputs.call_route_api}
        handleChange={handleChange}
        type="text"
        placeholder="Enter Call Route API URL"
      />
      <CustomInput
        label="Call Log Update API"
        name="call_log_update_api"
        value={inputs.call_log_update_api}
        handleChange={handleChange}
        type="text"
        placeholder="Enter Call Log Update API URL"
      />
    </div>
  );

  return (
    <GModal
      visible={visible}
      heading="LeadSquared Integration"
      body={body}
      closeModal={handleCancel}
      footerLeft={
        <a
          href="https://frejun.com/leadsquared-calling-integration/"
          className="gmodal-footer-link"
          target="_blank"
          rel="noreferrer"
        >
          View docs
        </a>
      }
      bottomButtons={[
        <Button
          key="cancel"
          variant="outlined"
          buttonText="Cancel"
          onClick={handleCancel}
          hierarchy="white"
        />,
        <Button
          key="connect"
          variant="contained"
          buttonText={
            Object.keys(config ?? {})?.length > 0 ? "Save" : "Connect"
          }
          disabled={
            !!inputs.call_log_api.error ||
            !!inputs.agent_popup_api.error ||
            !!inputs.call_route_api.error ||
            !!inputs.call_log_update_api.error
          }
          onClick={handleConnect}
          hierarchy="green"
        />,
      ]}
    />
  );
};

export default LeadSquaredConfigModal;
